var _circle, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle2, _path2, _ellipse, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoReportsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 124,
    r: 82,
    fill: "#F2F4F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 43,
    width: 116,
    height: 151,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#323A31",
    strokeOpacity: 0.18,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 43V68C148 75.18 153.82 81 161 81H184L148 43Z",
    fill: "#E1E5E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 89,
    width: 53,
    height: 9,
    rx: 4.5,
    fill: "#A8AEA6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 107,
    width: 72,
    height: 9,
    rx: 4.5,
    fill: "#D5D9D3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 125,
    width: 57,
    height: 9,
    rx: 4.5,
    fill: "#D5D9D3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 151,
    width: 13,
    height: 26,
    rx: 4,
    fill: "#8B9588"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 138,
    width: 13,
    height: 39,
    rx: 4,
    fill: "#5E685B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 123,
    width: 13,
    height: 54,
    rx: 4,
    fill: "#323A31"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 166,
    r: 33,
    fill: "#323A31",
    stroke: "#FFFFFF",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 153L186 179M186 153L160 179",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 203,
    rx: 74,
    ry: 9,
    fill: "#D8DDD6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 86,
    r: 5,
    fill: "#5E685B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 96,
    r: 5,
    fill: "#A8AEA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199 116V135M189.5 125.5H208.5",
    stroke: "#5E685B",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReportsFound);
export default __webpack_public_path__ + "static/media/no-reports-found.c5e82c05280a1c8a1d4e1171f09cabb6.svg";
export { ForwardRef as ReactComponent };